export const defaultSettingsSpace = {
  display: "Settings",
  value: "settings", // only purpose is to be unique so that tabbar functions properly
  valuePath: "kp_settings",
  pages: true,
};

export const createPage = (options = {}) => ({
  sectionName: options.id || "page0",
  /**
   * above is for backwards compat
   * can remove once we move all mappers to this block mapper
   * */
  pageId: options.id || "page0",
  blocks: [],
});
